import React from 'react';
import {
    HomeOutlined,
    ArrowLeftOutlined
} from '@ant-design/icons';
import { Layout, Button, theme, Flex, Row, Col, Typography } from 'antd';
import Logo from '../../assets/logo/mogu-logo-cover.png';
import { useNavigate } from 'react-router-dom';

const { Content } = Layout;
const { Text } = Typography;

const NotFound = () => {
    const navigate = useNavigate();

    const {
        token: {
            colorPrimary,
            colorPrimaryHover,
            colorPrimaryBorderHover,
            colorPrimaryBorder,
            colorPrimaryBgHover,
        },
    } = theme.useToken();

    const styles = {
        svg: {
            font: "20.5em 'Monoton'",
        },
        text: (color, delay) => ({
            fill: 'none',
            strokeDasharray: '8% 29%',
            strokeWidth: '5px',
            strokeDashoffset: '1%',
            stroke: color,
            animation: `strokeOffset 5.5s infinite linear`,
            animationDelay: delay,
        }),
    };

    return (
        <Layout style={{ height: "100svh", overflowY: "auto" }}>
            <Content style={{ overflowY: "auto" }}>
                <Row>
                    <Col xs={{
                        span: 20,
                        offset: 2,
                    }}
                        md={{
                            span: 18,
                            offset: 4,
                        }}
                        lg={{
                            span: 18,
                            offset: 4,
                        }}
                    >
                        <Flex vertical={true} justify='' style={{ height: "100svh", }}  >
                            <div>
                                <img src={Logo} height="36px" width='auto' alt='mogu' />
                            </div>
                            <Row>
                                <Col span={24}>
                                    <div style={{ height: 5, backgroundColor: colorPrimary, marginTop: 20 }}></div>
                                </Col>
                            </Row>
                            <Content>
                                <div>
                                    <svg viewBox="0 0 960 300" style={styles.svg}>
                                        <symbol id="s-text">
                                            <text textAnchor="middle" x="30%" y="90%">404</text>
                                        </symbol>

                                        <g className="g-ants">
                                            <use xlinkHref="#s-text" style={styles.text(colorPrimaryBgHover, '-1s')}></use>
                                            <use xlinkHref="#s-text" style={styles.text(colorPrimaryBorder, '-2s')}></use>
                                            <use xlinkHref="#s-text" style={styles.text(colorPrimaryBorderHover, '-3s')}></use>
                                            <use xlinkHref="#s-text" style={styles.text(colorPrimaryHover, '-4s')}></use>
                                            <use xlinkHref="#s-text" style={styles.text(colorPrimary, '-5s')}></use>
                                        </g>
                                    </svg>
                                </div>
                                <br />
                                <Text style={{ fontSize: 48, fontWeight: 400 }}>
                                    <span style={{color:colorPrimary, fontSize: 54}}>Sorry!,</span> this page isn't available
                                </Text>
                                <br />
                                <Text type='secondary' style={{ fontSize: 24, fontWeight: 400 }}>
                                    The page you were looking for couldn't be found
                                </Text>
                                <br/>
                                <br/>
                                <Flex align='center' gap={16} justify='flex-start'>
                                    <Button size='large' type="default" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
                                        Go Back
                                    </Button>
                                    <Button size='large' type="primary" icon={<HomeOutlined />} onClick={() => navigate('/dashboard')}>
                                        HomePage
                                    </Button>
                                </Flex>
                            </Content>
                        </Flex>
                    </Col>
                </Row>
            </Content>
            <style>{`
        @keyframes strokeOffset {
          100% {
            stroke-dashoffset: -35%;
          }
        }
      `}</style>
        </Layout>
    );
};
export default NotFound;
